import { ActionIcon, Tooltip } from "@mantine/core";
import { CSSProperties } from "react";

import SvgIcon from "../SvgIcon";

const CopyButton = ({
  title,
  text,
  color,
  size,
  style,
}: {
  title?: string;
  text: string;
  color?: string;
  size?: number;
  style?: CSSProperties;
}) => (
  <Tooltip label={title || "Copy"}>
    <ActionIcon
      variant="subtle"
      color="gray"
      size="lg"
      style={style}
      aria-label={"copy button"}
      onClick={() => navigator.clipboard.writeText(text)}
    >
      <SvgIcon name="Copy" color={color} size={size} />
    </ActionIcon>
  </Tooltip>
);

export default CopyButton;
